import React, { FC, useEffect, useState } from 'react'
import { ILoanPaymentPlanModel } from '@linqpal/models'
import { IDownPaymentDetails } from '@linqpal/models/src/types/routes'
import { PaymentPlanStep } from './PaymentPlanStep'
import { DownPaymentStep } from './DownPaymentStep'
import { PayInvoiceStep } from './PayInvoiceStep'
import RootStore from '../../../../store/RootStore'
import ApplicationStore from '../../../GeneralApplication/Application/ApplicationStore'

enum Steps {
  PAYMENT_PLAN,
  DOWN_PAYMENT,
  PAYMENT,
}

interface IProps {
  invoices: any
  onClose: () => void
  onSuccess: () => void
}

// TODO: VK: consider unifying this with InvoiceCreditPaymentFlow
// - reuse same flow with same components,
// - normal payment would be hosted in BtModal, application payment - in PaymentStepContainer

export const ApplicationWithPaymentFlow: FC<IProps> = ({
  invoices,
  onClose,
  onSuccess,
}) => {
  // using app store for backward compatibility only, to be removed
  const { getPaymentPlans } = ApplicationStore

  const [step, setStep] = useState(Steps.PAYMENT_PLAN)

  const [paymentPlan, setPaymentPlan] = useState<ILoanPaymentPlanModel | null>(
    null,
  )
  const [downPayment, setDownPayment] = useState<IDownPaymentDetails | null>(
    null,
  )

  const invoice = invoices[0]
  const totalAmount = invoices.reduce((sum, inv) => sum + inv.total_amount, 0)

  useEffect(() => {
    getPaymentPlans(invoice?._id, totalAmount)
  }, [invoice, totalAmount, getPaymentPlans])

  const downPaymentSettings =
    RootStore.userStore.company?.settings?.downPaymentDetails

  const useDownPayment =
    downPaymentSettings?.isRequired &&
    invoices?.some((i: any) => !!i.supplierInvitationDetails)

  const invoiceIds = invoices.map((i: any) => i._id)

  const handlePaymentPlanSelection = (
    loanPaymentPlan: ILoanPaymentPlanModel,
    downPaymentDetails: IDownPaymentDetails | null,
  ) => {
    setPaymentPlan(loanPaymentPlan)
    setDownPayment(downPaymentDetails)
  }

  return (
    <>
      {step === Steps.PAYMENT_PLAN && (
        <PaymentPlanStep
          invoices={invoices}
          paymentPlan={paymentPlan}
          onSelect={handlePaymentPlanSelection}
          onContinue={() =>
            setStep(useDownPayment ? Steps.DOWN_PAYMENT : Steps.PAYMENT)
          }
          onClose={onClose}
        />
      )}

      {step === Steps.DOWN_PAYMENT && downPayment && (
        <DownPaymentStep
          downPayment={downPayment}
          onContinue={(downPaymentDetails) => {
            setDownPayment(downPaymentDetails)
            setStep(Steps.PAYMENT)
          }}
          onBack={() => setStep(Steps.PAYMENT_PLAN)}
          onClose={onClose}
        />
      )}

      {step === Steps.PAYMENT && paymentPlan && (
        <PayInvoiceStep
          invoiceIds={invoiceIds}
          paymentPlan={paymentPlan}
          downPayment={downPayment}
          onSuccess={onSuccess}
          onBack={() =>
            setStep(useDownPayment ? Steps.DOWN_PAYMENT : Steps.PAYMENT_PLAN)
          }
          onClose={onClose}
        />
      )}
    </>
  )
}
